var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap default"},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.loading)?_c('LoadingAnimation'):_c('div',{staticClass:"default_center"},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }